import { AiOutlineNotification } from 'react-icons/ai';
import { FiExternalLink } from 'react-icons/fi';

export default function NotificationItem({ type, text, time }) {
  return (
    <div className="list-group-item px-2 py-0">
      <div className="border-start">
        <div className="d-flex ms-n6 pb-6">
          <div className=" me-3">
            <div className="d-flex align-items-center justify-content-center icon-shape text-base w-12 h-12 bg-soft-primary text-primary rounded-circle">
              <AiOutlineNotification size={30} />
            </div>
          </div>
          <div className="p-2 flex-fill">
            <div className="text-sm">
              <span className="text-heading text-sm font-bold">{type}</span>
            </div>
            <div className="mt-2">
              <p className="text-sm text-muted">{text}</p>
            </div>
          </div>
          <div className="me-auto p-2">
            <small className="d-block mb-1 text-muted">{time}</small>
          </div>
          <div className="me-auto p-2">
            <a className="">
              {' '}
              <FiExternalLink size={20} />{' '}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
